import type {ProviderData} from '../../auth/models/User';
import type {MyBrands, ProviderBrand} from '../../../types/ServiceProviderTypes';

interface NormalizedBrand {
  id: number;
  name: string;
}

function normalizeBrands (brands: ProviderBrand[] | Array<ProviderBrand & { id?: number; name?: string }> | undefined): NormalizedBrand[] {
  if (!Array.isArray(brands) || brands.length === 0) {
    return [];
  }

  return brands
    .map((brand) => ({
      id: Number.parseInt(
        String(
          (brand?.brandId ?? brand?.id ?? '')
        ).toString().trim(),
        10
      ),
      name: (
        brand?.brandName ??
        brand?.name ??
        ''
      ).toString().trim()
    }))
    .filter((brand) => Number.isFinite(brand.id) && brand.id > 0 && !!brand.name);
}

export function mapMyBrandsResponseToProviderData (
  response: MyBrands | ProviderBrand[] | undefined,
  fallbackProviderId: number
): ProviderData | undefined {
  if (!response) {
    return undefined;
  }

  if (Array.isArray(response)) {
    const normalizedBrands = normalizeBrands(response);
    return {
      providerId: fallbackProviderId,
      assignedBrands: normalizedBrands,
      companyName: undefined
    };
  }

  const myBrands = response as MyBrands;
  const normalizedBrands = normalizeBrands(myBrands?.brands);
  const parsedProviderId = Number.parseInt(String(myBrands?.providerId ?? '').trim(), 10);
  const providerId = Number.isNaN(parsedProviderId) ? fallbackProviderId : parsedProviderId;

  return {
    providerId,
    assignedBrands: normalizedBrands,
    companyName: myBrands?.providerName?.toString().trim() || undefined
  };
}

